module.exports = "<div class=\"mbgf-col-sm-12 data-module\">\n    <p>{{consent.mainlabel}}</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./js-src/markdown-editor/modules/consentmainlabel/consentmainlabel.html
// module id = 35
// module chunks = 0 1